// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FoWjYBy5S3qnJt {
  display: none;
}
.Twu6_ppBo4S42z:hover .FoWjYBy5S3qnJt {
  display: inline-block;
}
.uOXJhjp1mm1r6z {
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
}
.rF9d9cwo8rJrbP {
  margin-right: 4px;
}
.oQayfMrklkba4X {
  margin-right: 6px;
  font-weight: var(--ds-font-weight-bold, bold);
}
.Q99tmKgWXEbMbz {
  margin-right: 2px;
}
.PxL_3a0PSiOjGx {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
}
.PxL_3a0PSiOjGx a {
  color: var(--ds-text-subtle, #44546f);
}
.CNnn_p9MdDPBvP {
  margin-right: 2px;
}
.qESxI3wwG26uu2 {
  margin-top: 16px;
}
.Twu6_ppBo4S42z {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.Twu6_ppBo4S42z.ppDG0x6gZlR3HI {
  width: calc(100% - 40px);
}
.Twu6_ppBo4S42z.ppDG0x6gZlR3HI .Q99tmKgWXEbMbz {
  cursor: pointer;
}
.Twu6_ppBo4S42z.ppDG0x6gZlR3HI .oQayfMrklkba4X {
  font-weight: unset;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"copyLinkWrapper": `FoWjYBy5S3qnJt`,
	"wrapper": `Twu6_ppBo4S42z`,
	"editedMessage": `uOXJhjp1mm1r6z`,
	"copiedCommentMessageWrapper": `rF9d9cwo8rJrbP`,
	"commentMessageWrapper": `oQayfMrklkba4X`,
	"commentWrapper": `Q99tmKgWXEbMbz`,
	"footerWrapper": `PxL_3a0PSiOjGx`,
	"reactionPiles": `CNnn_p9MdDPBvP`,
	"deleteButton": `qESxI3wwG26uu2`,
	"boardComment": `ppDG0x6gZlR3HI`
};
export default ___CSS_LOADER_EXPORT___;
